function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import 'researcher/digital-orders/styles/digital-order-payment.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Navigate } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Loading from 'researcher/components/Loading';
import useRepeater from 'researcher/hooks/use-repeater';
import { T, useTranslate } from 'shared/helper/translate';
import { DATE_ONLY_FORMAT, dateString } from 'researcher/helpers/date';
import { price } from 'researcher/helpers/price';
import { recordTransaction } from 'researcher/helpers/gtm';
import CurrencySelect from 'researcher/order-form/payment/components/CurrencySelect';
import { updateUserCurrencySelection } from 'researcher/user/actions';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { BANK_TRANSFER, BOLETO, CREDITS } from 'researcher/domain/transaction/payment-method';
import { loadDigitalEditing } from 'researcher/digital-editing/actions';
import { getPurchaseInformation } from '../reducer';
import RubriqPaymentForm from './RubriqPaymentForm';
var RubriqCart = function RubriqCart() {
  var _curie$plans, _curie$plan$available3, _curie$plan$available4, _payment$receiptCodes;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    digitalPurchase = _useState2[0],
    setDigitalPurchase = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useParams = useParams(),
    success = _useParams.success,
    receiptCode = _useParams.receiptCode;
  var chinaLocalization = useSelector(getChinaLocalization);
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    application = _useSelector.application,
    user = _useSelector.user,
    digitalEdit = _useSelector.digitalEdit,
    payment = _useSelector.payment,
    curie = _useSelector.curie;
  var purchaseInformation = useSelector(function (state) {
    return getPurchaseInformation(state, receiptCode);
  });
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var digitalEditEnabled = !!digitalEdit.hasDigitalEditingPurchase;
  var premiumPlan = (_curie$plans = curie.plans) === null || _curie$plans === void 0 ? void 0 : _curie$plans.premium;
  var daysRemainingBeforePremiumPlanExpires = !premiumPlan || premiumPlan.status === 'expired' ? undefined : Math.ceil((new Date(premiumPlan.endsAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  var isRenewal = !!premiumPlan && daysRemainingBeforePremiumPlanExpires <= 21;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return dispatch(loadDigitalEditing());
      },
      numberOfSecondsBetweenCalls: 10
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;

  // Checking that endsAt comes after today shouldn't be needed, but doesn't hurt as one last sanity check
  var currentPlanEndsAt = (premiumPlan === null || premiumPlan === void 0 ? void 0 : premiumPlan.status) === 'active' && moment(premiumPlan === null || premiumPlan === void 0 ? void 0 : premiumPlan.endsAt) > moment() ? premiumPlan.endsAt : undefined;
  var handleCurrencySubmission = function handleCurrencySubmission(currencyIso) {
    return dispatch(updateUserCurrencySelection(currencyIso));
  };
  useEffect(function () {
    if (success) {
      startUpdating();
    }
    return function () {
      return stopUpdating();
    };
  }, []);
  useEffect(function () {
    if (digitalEdit.enabled) {
      stopUpdating();
    }
  }, [digitalEditEnabled]);
  useEffect(function () {
    var _curie$plan$available;
    if (!digitalPurchase && ((_curie$plan$available = curie.plan.availablePlans) === null || _curie$plan$available === void 0 || (_curie$plan$available = _curie$plan$available.premium) === null || _curie$plan$available === void 0 ? void 0 : _curie$plan$available.length) > 0) {
      var _curie$plan$available2;
      setDigitalPurchase((_curie$plan$available2 = curie.plan.availablePlans) === null || _curie$plan$available2 === void 0 ? void 0 : _curie$plan$available2.premium[0]);
    }
  }, [((_curie$plan$available3 = curie.plan.availablePlans) === null || _curie$plan$available3 === void 0 ? void 0 : _curie$plan$available3.premium) && ((_curie$plan$available4 = curie.plan.availablePlans) === null || _curie$plan$available4 === void 0 ? void 0 : _curie$plan$available4.premium.length)]);
  useEffect(function () {
    if (purchaseInformation) {
      recordTransaction(purchaseInformation);
    }
  }, [purchaseInformation !== null]);
  if (!paddleBillingForChina) {
    if (!digitalPurchase) {
      return /*#__PURE__*/React.createElement(Loading, null);
    }
  }
  if (!chinaLocalization || paddleBillingForChina) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq/plan/subscribe",
      replace: true
    });
  }
  if (!application.allowsDigitalEditing) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  if (digitalEditEnabled && success && purchaseInformation) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto digital-edit-payment rubriq-cart g-padding"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Digital Editing"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rubriq-section-header py-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.checkout"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, success && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "curie.purchase-plan-loading-notice"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    inline: true,
    source: "curie.cart-summary"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cart-summary-content border p-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.premium"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.plan-billing-period-yearly"
  }), ', ', " ", /*#__PURE__*/React.createElement(T, {
    source: "curie.expiring"
  }), ' ', dateString(t, moment(premiumPlan === null || premiumPlan === void 0 ? void 0 : premiumPlan.startsAt).add(1, 'year'), DATE_ONLY_FORMAT)), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, price(user.currency, digitalPurchase.price, true, true))))), isRenewal && /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.cart-renewal-details-title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.cart-renewal-details-content",
    params: {
      planRemainingDays: daysRemainingBeforePremiumPlanExpires
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.invoicing"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /*#__PURE__*/React.createElement(T.md, {
    className: "fapiao-notice",
    source: "fapiao-after-payment-notice",
    linkRenderer: function linkRenderer(_ref) {
      var href = _ref.href,
        children = _ref.children;
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, children);
    }
  }))), !success && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.select-payment-method"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, !user.currencyIso ? /*#__PURE__*/React.createElement(CurrencySelect, {
    handleCurrencySubmission: handleCurrencySubmission
  }) : null, /*#__PURE__*/React.createElement(RubriqPaymentForm, {
    additionalData: {
      availableDigitalPurchaseIdentity: digitalPurchase.identity
    },
    currency: user.currency,
    convertNumberOfInstallments: user.currency !== 'USD',
    excludePaymentMethods: [BANK_TRANSFER, BOLETO, CREDITS],
    paymentsEndpoint: "/api/digital-edit/payment",
    bankTransferDisabled: true,
    receiptCode: (_payment$receiptCodes = payment.receiptCodes) === null || _payment$receiptCodes === void 0 ? void 0 : _payment$receiptCodes.digital,
    total: digitalPurchase.price,
    submitDisabled: !user.currencyIso
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Pay now'),
    type: "submit",
    disabled: payment.status.saving || payment.status.loading || !user.currencyIso,
    className: "btn btn-primary btn-squared-large payment-button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Pay now"
  })), payment.status.saving ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null))))));
};
export default RubriqCart;